import { render, staticRenderFns } from "./addContribute.vue?vue&type=template&id=636eb759&"
import script from "./addContribute.vue?vue&type=script&lang=js&"
export * from "./addContribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports